import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFlipboardComponent } from './simple-icons-flipboard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFlipboardComponent ],
    exports:      [ SimpleIconsFlipboardComponent ],
    bootstrap:    []
})
export class SimpleIconsFlipboardModule {}
